// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"ad9d8932","977":"5b94554e"}[chunkId] + ".chunk.js";
};